module.exports = __webpack_public_path__ + "img/get-help.720e3208.svg";